import Thumbnail from "./thumbnail"
import GeneralHelper from "./generalHelper"
import MetaFiles, { Type } from "./metafiles"
import View from "./View"
import MessageDictionary from "./MessageDictionary"

export default class Category
{
  static load_logos$()
  {
    var q = { "Match":{"Archived":false,"Owned":false,"Shared":true, "Class2": "logo" },"Start":0,"SortBy":"Modified","SortDir":"Desc", "IncludeData": true, "HasClass2": true };
    
    let hash = GeneralHelper.md5Encode(JSON.stringify(q));

    var logos = GeneralHelper.getPatternContainersFromLocalStorage('logos', hash);

    if( logos && logos.Items && logos.Items.length > 0 )
    {
      Cx.Core.Document.search$(q).then(function(r) {
        GeneralHelper.savePatternContainersToLocalStorage('logos', hash, r);
      });
      return Cx.resolve(logos);
    }      
    else {
      return Cx.Core.Document.search$(q).then(function(r) {
        GeneralHelper.savePatternContainersToLocalStorage('logos', hash, r);
        return Cx.resolve(r);
      });
    }
  }

  static get_parent_designer_location(parent)
  {
    return parent.split("/").slice(0, 4).join("/") ;
  }

  static get_child_logos( logos, parent, repeat = true )
  {
    let children = [];
    Cx_.forEach(logos, function(l) {
      var is_child = ( Cx_.filter(l.Tags, function(t) {
        return (  t.Name.toLowerCase() === parent.toLowerCase() ) ;
      }).length > 0 );
      //if ( is_child && l.Class1 === "published" )
      if ( is_child )
        children.push(l);
    });
    // let children = Cx_.filter(logos, function(l) {
    //   return (  ( Cx_.filter(l.Tags, function(t) {
    //     return ( Category.get_location_name( t.Name.toLowerCase() ) === Category.get_location_name( parent.toLowerCase() ) )
    //   }).length > 0));
    // } );

    return children ;
  }

  static get_location_name(parent)
  {
    parent = parent.split('/');
    if ( parent.length > 2 )
    {
      parent.shift() ; 
      parent.shift() ;//remove private public
    }
    parent = parent.join('/');
    return parent ;
  }

  static process$( element, parent, render = true, bigThumbs)
  {
    View.wizardLoading(true, true, true);    
    if ( window.AppInstance.is_root() && !window.AppInstance.is_favorite_search )
      $('#'+element).append("<div id=\"view-favorites\" class=\"designer-select check-logged-in\" title=\"My "+MessageDictionary.translate(window.PatternBuilder.config().LOCALE, 'favorites')+"\" style=\"background-image:url(https://assets.stahls.com/stahls/images/my-favorites.png); background-size:90%, 90%;\"></div>");
    return Category.load_logos$().then(function(logos) { 
      let p = [];
      View.wizardLoading(true, true, false);
      var match = { "Match":{"Archived":false,"Hidden":false,"Owned":false,"Shared":true,"Type":"Doc"},"Text": parent};
      return Cx.Core.Tag.searchTree$(match).then(function(sub_cats){
        let cat_logos = [];
        Cx_.forEach(sub_cats, function(cat) {
          let sub_logos = Category.get_child_logos(logos.Items, cat.Name);
          Cx_.forEach(sub_logos, function(sl) {
            cat_logos.push(sl);
          });
        });
        // if ( window.PatternBuilder.config().SETNAME.toLowerCase().indexOf('public') > -1 )
        //   cat_logos = Cx_.filter( cat_logos, function(c) { return ( c.Class1 === 'published' ) ; });
        if ( cat_logos.length > 0 )
        {          
          Cx_.forEach(cat_logos, function(c, i) {
            var new_cat = ( c.Class3 !== undefined && c.Class3 !== "" && ( c.Class3 > new Date().valueOf() ) );
            var thumb_html ;
            if ( bigThumbs ) {
              thumb_html = '<div id="designer_select_content_'+String(bigThumbs)+String(i)+'" class="designer-select" onclick="window.load_content$(\'' + element + '\', \'' + MetaFiles.get_child_tag(c.Tags, parent) + '\', false);" title="' + GeneralHelper.remove_extension(c.Name) + '" style=""><div ' + (new_cat ? 'class="swatch-new"' : '') + '></div>'
            } else {
              thumb_html = '<div style="position:relative;" class="pattern-select collection-select" onclick="window.load_content$(\'' + element + '\', \'' + MetaFiles.get_child_tag(c.Tags, parent) + '\', false);" title="' + GeneralHelper.remove_extension(c.Name) + '"><span class="pattern-name collection-name">' + GeneralHelper.remove_extension(c.Name) + '</span><div ' + (new_cat ? 'class="swatch-new"' : '') + '><div class="pattern-container"><img  id="designer_select_content_'+String(bigThumbs)+String(i)+'" class="main-thumb" /></div></div>';
            }
            $('#'+element).append(thumb_html);
          });
          Cx_.forEach(cat_logos, function(c,j) {
            p.push(Thumbnail.render_thumb_img$(c.Id,
              1,
             window.AppInstance.is_root() ? 330 : 180,
             window.AppInstance.is_root() ? 200 : 180,
              96,
             window.AppInstance.is_root() ? "Cover" : "Preserve",
              render).then(function(thumb){
                if ( render )
                {
                  if ( bigThumbs ) {
                    $('#designer_select_content_'+String(bigThumbs)+String(j)).css('background-image', 'url(' + thumb + ')');
                  }else{
                    $('#designer_select_content_'+String(bigThumbs)+String(j)).attr('src', thumb);
                  }                  
                }
              }));
          });
          View.resize();
        }
        return Cx.whenAll(p);
      });
    });
  };

  static load_children$(parent) //this could be pattern or sub categories, at this point we don't know
  {
    var q = { "Match":{"Archived":false,"Owned":false,"Shared":true
    , Tags: [{"Name": parent, Owned: true, Shared: true }] }
    ,"Start":0,"SortBy":"Modified","SortDir":"Desc", "IncludeData": true };

    let hash = GeneralHelper.md5Encode(JSON.stringify(q));

    var patternCategories = GeneralHelper.getPatternContainersFromLocalStorage('category', hash);

    if(patternCategories && patternCategories.Items && patternCategories.Items.length > 0 )
    {
      Cx.Core.Document.search$(q).then(function(child) {
        GeneralHelper.savePatternContainersToLocalStorage('category', hash, child);        
      });
      return Cx.resolve(patternCategories);
    }
    else {
      return Cx.Core.Document.search$(q).then(function(child) {
        GeneralHelper.savePatternContainersToLocalStorage('category', hash, child);
        return Cx.resolve(child);
      });
    }
  }

  static get_meta_files(cats)
  {
    return Cx_.filter(cats, function(doc) { return ( ( doc.Class2 === Type.logo_document || doc.Class2 === Type.header_document ) ); } );
  }

  static get_header(cats)
  {
    return Cx_.filter(cats, function(doc) { return ( doc.Class2 === Type.header_document ); } );
  }

  static get_logo(cats)
  {
    return Cx_.filter(cats, function(doc) { return ( doc.Class2 === Type.logo_document ); } );
  }

  static get_category_thumb_link(doc_id, zoom, width, height, dpi, fit)
  {
    var qs = {
      config: Cx.Core.getConfig()
      , model: {
          Doc: {
              Id: doc_id
          }
      , format: 'Png'
      , Zoom: 1
      // , Width: width
      // , Height: height
      // , DPI: dpi
      , Fit: fit
      }
      , ident: { SessionId: Cx.User.getSessionId(), SuperUser: Cx.User.isSuperUser() }
    };

    return Cx.Core.getServer() + '/Core2/Doc/Thumbnail?' + encodeURIComponent(JSON.stringify(qs));
  };
}